const SITE_STORAGE_PREFIXES = ['watchlist', 'forum-', 'kitapcik', 'theme', 'lang'];

function shouldRemoveStorageKey(key: string): boolean {
  const lower = key.toLowerCase();
  return SITE_STORAGE_PREFIXES.some((p) => lower.includes(p));
}

/** Bu tarayıcıda site önbelleği, service worker ve ilgili localStorage temizler. */
export async function purgeBrowserSiteCache(): Promise<{
  swCount: number;
  cacheCount: number;
  storageKeys: number;
}> {
  let swCount = 0;
  let cacheCount = 0;
  let storageKeys = 0;

  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
    swCount = regs.length;
  }

  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.map((n) => caches.delete(n)));
    cacheCount = names.length;
  }

  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k) keys.push(k);
    }
    keys.forEach((k) => {
      if (shouldRemoveStorageKey(k)) {
        localStorage.removeItem(k);
        storageKeys += 1;
      }
    });
  } catch {
    /* private mode */
  }

  sessionStorage.clear();

  return { swCount, cacheCount, storageKeys };
}

export function hardReloadPublicSite(): void {
  const url = new URL(window.location.origin);
  url.searchParams.set('_cb', String(Date.now()));
  window.location.href = url.toString();
}
